<template>
  <v-row :class="$vuetify.breakpoint.smAndUp ? 'px-10' : 'px-8'" class="py-2">
    <template v-for="(item, index) in data">
      <v-col :key="'dataitem-' + index" class="pa-2" cols="12" lg="6">
        <v-row>
          <v-col class="pa-0" lg="5" sm="6" cols="12">
            {{ item.name }} :
          </v-col>
          <v-col
            :class="$vuetify.breakpoint.xsOnly ? 'pl-2' : ''"
            class="pa-0 grey--text"
            lg="7"
            sm="6"
            cols="12"
          >
            {{ item.value }}</v-col
          >
        </v-row>
      </v-col>
      <v-col
        v-if="singleline && $vuetify.breakpoint.lgAndUp"
        :key="'dataitem2-' + index"
      ></v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  props: ['data', 'singleline']
}
</script>
